<script setup>
const props = defineProps({
  isShow: {
    type: Boolean,
    required: true
  },
});
const emits = defineEmits(['request-close']);
const siteUrl = document.querySelector('meta[name="site-url"]').content;
</script>

<template>
  <div v-if="isShow">
    <div :class="{modDrawerModalWindow: true, isShow}">
      <div class="modDrawerModalTitleContainer">
        <p class="pFont16 pFontBold">投稿ルール</p>
        <button
          type="button"
          class="lyHvCnt lyColumn lyW48px lyH48px pFont10 pFontBold"
          style="flex-grow: 0"
          @click="emits('request-close')"
        >
          <span class="lyBlock lyW24px"><img
            :src="siteUrl+'images/iconClose.svg'"
            loading="lazy"
            alt=""
            width="30"
            height="31"
          ></span>
          とじる
        </button>
      </div>
      <div class="modDrawerModalBottomWrapper">
        <div class="lyPd16 pFont14 pBackColorWhite pBorderRadius4px">
          <p class="lyMb16 pFontBold">【プライバシーと匿名性の尊重】</p>
          <p class="lyMb16">たとえ匿名であっても関係者が見れば内容を特定できるような、個人情報（氏名・住所・電話番号・職業・メールアドレスなど）を記入すると重大なトラブルの元となります。絶対に書き込まないようお願いします。<br>
            てつなぎでは個人情報保護の重要性を認識し、投稿者のメールアドレス等の個人情報を厳重に管理し慎重に取り扱っています。詳しくは「<a href="https://commitgrowth.co.jp/privacy_policy/" class="pTextUnderLine">プライバシーポリシー</a>」をお読みください。</p>
          <p class="lyMb16 pFontBold">【公共のルールや法律の順守】</p>
          <p class="lyMb16">投稿は、公共のルールや法律に違反しないようにしてください。<br>
            誹謗中傷、人種差別、性差別、暴力的な表現、違法行為の推奨など、他人を傷つける可能性のある内容は禁止です。</p>
          <p class="lyMb16 pFontBold">【公共の秩序と安全の確保】</p>
          <p class="lyMb16">公共の秩序を乱すような行為や、他の利用者に対する嫌がらせ、脅迫、ストーキングなどの行為は禁止です。<br>
            自殺や自傷行為、犯罪行為の推奨や助長など、他人の安全を脅かす投稿は禁止です。</p>
          <p class="lyMb16 pFontBold">【コンテンツの適切なカテゴリへの投稿】</p>
          <p class="lyMb16">投稿は、適切なカテゴリに関連する内容であることを確認してください。<br>
            カテゴリに関係のないスパム投稿や宣伝行為は禁止です。</p>
          <p class="lyMb16 pFontBold">【良識と思いやりの原則】</p>
          <p class="lyMb16">共有する情報や意見は、他の人に対する配慮と尊重を持って行ってください。<br>
            議論や意見の相違はあっても、相手を攻撃せず、建設的な会話を心がけましょう。</p>
          <p class="lyMb16 pFontBold">【適切な言葉遣いと表現】</p>
          <p class="lyMb16">投稿は、適切な言葉遣いで行い、他の人を侮辱したり、攻撃的な表現を避けてください。<br>
            不適切な内容や語彙、下品な表現は禁止です。</p>
          <p class="lyMb16 pFontBold">【管理者の指示への従順】</p>
          <p class="lyMb16">掲示板の管理者が指示したルールや要請には従ってください。<br>
            違反行為や問題の報告に対して、管理者へ協力的に対応してください。<br>
            これらのルールは、掲示板の健全な運営と利用者の安全を確保するために重要です。<br>
            また、掲示板の利用者にもこれらのルールを遵守する責任があります。<br>
            掲示板上で違反行為が発見された場合、管理者は適切な措置（例：警告、投稿の削除、アカウントの停止など）を取ることがあります。</p>
        </div>
      </div>
    </div>
    <div
      :class="{gbModalBack: true, mdPopUp: true, isShow}"
      @click="emits('request-close')"
    ></div>
  </div>
</template>
